// extracted by mini-css-extract-plugin
export default {"sectionContainer":"msa_sectionContainer__lnvSH","column":"msa_column__gA+JL","columnHeader":"msa_columnHeader__BPSIf"};